var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacyStyle"},[_c('headerComponent',{attrs:{"loginType":_vm.loginType},on:{"child-event":_vm.changePageContent}}),_c('div',{staticClass:"textContent"},[_c('iframe',{attrs:{"src":_vm.pdfurl,"frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }